/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-cycle
import { fireUtagEvent, Analytics } from '@garmin/support-analytics';

// eslint-disable-next-line import/prefer-default-export
export const triggerSearchQueryAnalytics = (videoResults, textResults, textResultsPrivate, product, noProductFlowFlag, search) => {
  if (search) {
    search = search.toLowerCase();
  }
  if (videoResults?.suggestedSearch) {
    videoResults.suggestedSearch = videoResults.suggestedSearch.toLowerCase();
  }
  if (textResults?.suggestedSearch) {
    textResults.suggestedSearch = textResults.suggestedSearch.toLowerCase();
  }
  if (textResultsPrivate?.suggestedSearch) {
    textResultsPrivate.suggestedSearch = textResultsPrivate.suggestedSearch.toLowerCase();
  }

  const productFlow = noProductFlowFlag ? 'No Product' : 'Product';
  const videoOrTextResultsSuggestedSearch = videoResults?.suggestedSearch || textResults?.suggestedSearch;

  if (videoResults?.suggestedSearch || textResults?.suggestedSearch) {
    fireUtagEvent([
      productFlow,
      'Search - No Results',
      search,
      product?.displayName,
    ]);
    fireUtagEvent([
      productFlow,
      'Search - Suggested - Replaced Specific Terms',
      videoOrTextResultsSuggestedSearch,
      product?.displayName,
    ]);

    if (!videoResults?.contentDetails?.length && !textResults?.contentDetails?.length && !textResultsPrivate?.contentDetails?.length) {
      // eslint-disable-next-line max-len
      fireUtagEvent([
        productFlow,
        'Search - Suggested - Replaced Specific Terms - No Results',
        videoOrTextResultsSuggestedSearch,
        product?.displayName,
      ]);
    }
  } else if (!videoResults?.contentDetails?.length && !textResults?.contentDetails?.length && !textResultsPrivate?.contentDetails?.length) {
    fireUtagEvent([
      productFlow,
      'Search - No Results',
      search,
      product?.displayName,
    ]);
    fireUtagEvent([
      productFlow,
      'Search - No Results - No Suggestion',
      search,
      product?.displayName,
    ]);
  }
};

export const identificationSuccessCategory = () => {
  const currentUrl = window.location.href;
  let category = 'product-identification-success-landing';

  if (currentUrl.includes('faq')) {
    category = 'product-identification-success-faq';
  } else if (currentUrl.includes('focus')) {
    switch (currentUrl.split('focus=')[1].split('&')[0]) { //eslint-disable-line
      case 'topics':
        category = 'product-identification-success-contact';
        break;
      case 'manuals':
        category = 'product-identification-success-manuals';
        break;
      case 'videos':
        category = 'product-identification-success-videos';
        break;
      case 'software':
        category = 'product-identification-success-software';
        break;
    }
  }

  return category;
};

export const removeProductSearchCategory = () => {
  const currentUrl = window.location.href;
  let category = '_remove-product-search-landing';

  if (currentUrl.includes('faq')) {
    category = '_remove-product-search-faq';
  } else if (currentUrl.includes('focus')) {
    category = '_remove-product-search-transition';
  }

  return category;
};

const getManualAnalyticsParams = (eventName, label, action, category) => {
  let manualAnalyticsEvent = {};
  if (eventName) manualAnalyticsEvent = Analytics.getAnalyticsEventParams(eventName);

  manualAnalyticsEvent.label = label || manualAnalyticsEvent.label;
  manualAnalyticsEvent.action = action || manualAnalyticsEvent.action;
  manualAnalyticsEvent.category = category || manualAnalyticsEvent.category;

  return manualAnalyticsEvent;
};

// eslint-disable-next-line import/prefer-default-export
export const trackEventFor = (eventName, label, action, category) => {
  const manualAnalyticsEvent = getManualAnalyticsParams(eventName, label, action, category);

  Analytics.trackAnalyticsEvent({
    manualAnalyticsEvent,
  });
};

export const trackEventMapFor = (label, action, category, productName, getEventName = identificationSuccessCategory) => {
  let eventName = '';

  if (typeof getEventName === 'function') {
    eventName = getEventName();
  } else if (typeof getEventName === 'string') {
    eventName = getEventName;
  }

  const manualAnalyticsEvent = getManualAnalyticsParams(eventName, label, action, category);

  const eventMap = {};

  eventMap.page_type = category || manualAnalyticsEvent.category;
  eventMap.link_type = action || manualAnalyticsEvent.action;

  if (productName) eventMap.product_name = productName;

  eventMap.manualAnalyticsEvent = manualAnalyticsEvent;

  Analytics.trackAnalyticsEvent(
    eventMap,
  );
};
